import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase";

interface Request {
  id: string;
  isProcessed: boolean;
}

interface Response {
  success: boolean;
  message: string;
}

export const updateInfoChangeRequest = async (
  id: string,
  isProcessed: boolean,
) => {
  const functions = getFirebaseFunctions();
  const updateInfoChangeRequestFunction = httpsCallable<
    Request,
    Response,
    object
  >(functions, "admin_updateInfoChangeRequest");
  const res = await updateInfoChangeRequestFunction({
    id,
    isProcessed,
  });
  return res.data;
};
